import React__default from 'react';

const defaultTag = 'div';
const Base = ({ as, forwardRef, ...rest }) => React__default.createElement(as || defaultTag, { ref: forwardRef, ...rest });
Base.displayName = 'Base';

export { Base };
//# sourceMappingURL=Base.js.map
